import React, { useRef, useEffect } from 'react';
import { useLocale } from '../i18n/LocaleContext';

function getLogColor(level) {
  switch (level) {
    case 'error': return '#0a0a0a';
    default: return '#a3a3a3';
  }
}

function LogViewer({ logs }) {
  const { t, dateLocale } = useLocale();
  const logRef = useRef(null);
  useEffect(() => { if (logRef.current) logRef.current.scrollTop = logRef.current.scrollHeight; }, [logs]);

  return (
    <div className="log-viewer">
      <div className="section-heading">{t('logs.title')}</div>
      <div className="activity-list" ref={logRef} style={{ maxHeight: '60vh' }}>
        {logs.length === 0 && <p className="no-logs">{t('logs.empty')}</p>}
        {logs.map((log, i) => (
          <div key={i} className="activity-item" style={{ borderLeft: `3px solid ${getLogColor(log.level)}` }}>
            <span className="activity-time">{new Date(log.timestamp).toLocaleTimeString(dateLocale)}</span>
            <span className="activity-message" style={{ color: getLogColor(log.level) }}>{log.message}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LogViewer;
